// src/Api/apiendpoints.js
import baseapi from "./baseapi";

/**
 * Get Feedback Summary (Public API)
 * GET /public/feedback-summary
 */
export const getFeedbackSummary = async () => {
  const response = await baseapi.get("/public/feedback-summary");
  return response.data;
};
